module.exports = __webpack_public_path__ + "img/tuc.7f722092.png";